import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { AppComponent } from 'src/app/app.component';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HomeComponent } from '../home.component';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  model: any;
  roles = [];
  settingForm: FormGroup;

  // tslint:disable-next-line: max-line-length
  constructor( private authService: AuthService, private fb: FormBuilder, private toastrService: ToastrService, private appComponent: AppComponent, private homeComponent: HomeComponent) { }

  ngOnInit() {
    this.authService.isAuthenticated();
    this.appComponent.setTitle('Settings');

    this.authService.pageVisit().subscribe(() => {
    }, error => {
        console.log(error);
    });

    this.CreateSettingForm();
    this.getSettingData();
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }

  CreateSettingForm() {
    this.settingForm = this.fb.group({
      userRegister: [false, Validators.nullValidator],
      emailVerificationDisable: [false, [Validators.nullValidator]],
      userRole: ['', [Validators.required]],
      recoverPassword: [false, [Validators.nullValidator]],
      changePassword: [false, [Validators.nullValidator]],
      changeProfile: [false, [Validators.nullValidator]],
      twoFactorEnabled: [false, [Validators.nullValidator]],
      externalLogin: [false, [Validators.nullValidator]]
    });
  }

  getSettingData() {
    this.authService.getSettingData().subscribe(data => {
      this.roles = data.roles;
      if (data.settings[0].userRole == null) {
        data.settings[0].userRole = '';
      }
      this.settingForm = this.fb.group({
        userRegister: [data.settings[0].userRegister, Validators.nullValidator],
        emailVerificationDisable: [data.settings[0].emailVerificationDisable, [Validators.nullValidator]],
        userRole: [data.settings[0].userRole, [Validators.required]],
        recoverPassword: [data.settings[0].recoverPassword, [Validators.nullValidator]],
        changePassword: [data.settings[0].changePassword, [Validators.nullValidator]],
        changeProfile: [data.settings[0].changeProfile, [Validators.nullValidator]],
        twoFactorEnabled: [data.settings[0].twoFactorEnabled, [Validators.nullValidator]],
        externalLogin: [data.settings[0].externalLogin, [Validators.nullValidator]]
      });
      console.log('Data fetched successfully');
    }, error => {
      console.log(error);
    });
  }

  update() {
    if (this.settingForm.valid) {
      this.model = Object.assign({}, this.settingForm.value);
      this.authService.updateSetting(this.model).subscribe(data => {
        console.log('Update setting successfully');
        this.toastrService.success('Success', 'Update setting successfully');
      }, error => {
        console.log(error);
        this.toastrService.error('Failed', 'Update failed');
      });
    } else {
      this.appComponent.validateAllFormFields(this.settingForm);
    }
  }

  Cancel() {
    this.getSettingData();
  }

}
